var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v(" Hier kannst du den aktuellen Spielstand sehen. Bei einer aktiven Internetverbindung aktualisiert sich diese Seite automatisch. ")]),_c('LiveRankComponent',{attrs:{"gameDbName":_vm.gameDbName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }